import * as React from "react";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {RNTagItem, RNTagItemProps} from "./RNTagItem";
import {Children, ReactElement} from "react";
import {RNTags} from "./RNTags";

export class RNTagGroup extends React.Component<RNTagGroupProps, RNTagGroupState> {
    static defaultProps: Partial<RNTagGroupProps> = {};

    constructor(props: RNTagGroupProps) {
        super(props);
        this.state = {};
        this.props.children
    }

    public render() {
        let childrens:ReactElement<RNTagItemProps>[]=Children.toArray(this.props.children) as any;

        return (
            <AccordionItem Title={this.props.Title} IsOpen={true}>
                <div style={{margin:-10}}>
                    {childrens.map(x=> React.cloneElement<RNTagItemProps>(x,{
                        onClick:()=>this.props.onClick&&this.props.onClick(x.props.Value)
                    }))}
                </div>
            </AccordionItem>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface RNTagGroupProps {
    Title:string;
    onClick:(x:string)=>void;
    IsOpen:boolean;
}

interface RNTagGroupState {

}

//#endregion "My Region"